import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listahistorialdevoluciondetalle',
  templateUrl: './listahistorialdevoluciondetalle.component.html',
  styleUrls: ['./listahistorialdevoluciondetalle.component.css']
})
export class ListahistorialdevoluciondetalleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
